import { createContext } from 'react';
import { AppAbility } from '../../lib/ability';
import { createMongoAbility } from '@casl/ability';


const defaultAbility = createMongoAbility<AppAbility>();

export const AbilityContext = createContext<AppAbility>(defaultAbility);
